import get from './group/get'
import category from './group/category'
import list from './group/list'
export default {category,get,list}
